import {useState} from "react";
import AnomalyDetectionService from "../services/api/anomaly-detection";
import {useSnackbar} from "notistack";

const useAnomalyDetection = () => {

    const {enqueueSnackbar} = useSnackbar();

    const [anomalyDetectionDetails, setAnomalyDetectionDetails] = useState(null);
    const [isCreatingAnomalyDetectionRemarks, setCreatingAnomalyDetectionRemarks] = useState(false);
    const [isRemarksSaved, setRemarksSaved] = useState(false);
    const [isInvalidatingAnomalyDetectionRemarks, setInvalidatingAnomalyDetectionRemarks] = useState(false);
    const [isRemarksInvalidated, setRemarksInvalidated] = useState(false);
    const [anomalyHistoryLogList, setAnomalyHistoryLogList] = useState([]);
    const [isFetchingAnomalyDetails, setFetchingAnomalyDetails] = useState(false);
    const [anomalyList, setAnomalyList] = useState([]);
    const [isFetchingAnomalyList, setFetchingAnomalyList] = useState(false);
    const [searchedResult, setSearchedResult] = useState([]);
    const [isSearchingOVI, setSearchingOVI] = useState(false);
    const [anomalyDetectionList, setAnomalyDetectionList] = useState([]);
    const [isFetchingAnomalyDetectionList, setIsFetchingAnomalyDetectionList] = useState(false);
    
    const getAnomalyDetectionDetailView = (anomalyId) => {
        setFetchingAnomalyDetails(true);

        AnomalyDetectionService.getAnomalyDetectionDetailView(anomalyId).then((res) => {
            console.log("getAnomalyDetectionDetailView data xxxx", res.data);
            
            if (res.data.success) {
                setAnomalyDetectionDetails(res.data.data);
                setFetchingAnomalyDetails(false); 
                setRemarksSaved(false);     
                setRemarksInvalidated(false);  
            }

        }).catch((error) => {
            console.log("getAnomalyDetectionDetailView error xxxx", error);
            setFetchingAnomalyDetails(false);  
        })
    }

    const createAnomalyDetectionRemarks = (anomalyId, remarks) => {
        setCreatingAnomalyDetectionRemarks(true);

        AnomalyDetectionService.createAnomalyDetectionRemarks(anomalyId, remarks).then((res) => {
            console.log("createAnomalyDetectionRemarks data xxxx", res.data);
            
            if (res.data.success) {
                setCreatingAnomalyDetectionRemarks(false);
                setRemarksSaved(true);
                
                enqueueSnackbar("Successfully saved remarks", { 
                    variant: "success",
                    autoHideDuration: 3000
                });
            }

        }).catch((error) => {
            setCreatingAnomalyDetectionRemarks(false);
            console.log("createAnomalyDetectionRemarks error xxxx", error);
        })
    }

    const invalidateAnomalyDetectionRemarks = (anomalyId, remarks) => {
        setInvalidatingAnomalyDetectionRemarks(true);

        AnomalyDetectionService.invalidateAnomalyDetectionRemarks(anomalyId, remarks).then((res) => {
            console.log("invalidateAnomalyDetectionRemarks data xxxx", res.data);
            
            if (res.data.success) {
                setInvalidatingAnomalyDetectionRemarks(false);
                setRemarksInvalidated(true);

                enqueueSnackbar("Successfully invalidated remarks", { 
                    variant: "success",
                    autoHideDuration: 3000
                });
            }

        }).catch((error) => {
            setInvalidatingAnomalyDetectionRemarks(false);
            console.log("invalidateAnomalyDetectionRemarks error xxxx", error);
        })
    }

    const getHistoryLogList = (anomalyId) => {
        AnomalyDetectionService.getHistoryLogList(anomalyId).then((res) => {
            console.log("getHistoryLogList data xxxx", res.data);
            
            if (res.data.success) {
                setAnomalyHistoryLogList(res.data.data);        
            }

        }).catch((error) => {
            console.log("getHistoryLogList error xxxx", error);
        })
    }

    const getAnomalyList = (startDate, endDate, selectedFraud) => {
        setFetchingAnomalyList(true);
        setSearchingOVI(false);
        setSearchedResult([]);

        AnomalyDetectionService.getAnomalyList(startDate, endDate, selectedFraud).then((res) => {
            console.log("getAnomalyList data xxxx", res.data);
            
            if (res.data.success) {
                setAnomalyList(res.data.data);    
                setFetchingAnomalyList(false);
            }

        }).catch((error) => {
            console.log("getAnomalyList error xxxx", error);
            setFetchingAnomalyList(false);
        })
    }

    const getSearchAnomalyList = (startDate, endDate, ovi) => {
        setFetchingAnomalyList(true);
        setAnomalyList([]);

        AnomalyDetectionService.getSearchAnomalyList(startDate, endDate, ovi).then((res) => {
            console.log("getSearchAnomalyList data xxxx", res.data);
            
            if (res.data.success) {
                setSearchedResult(res.data.data);  
                setFetchingAnomalyList(false);
                setSearchingOVI(true);
            }

        }).catch((error) => {
            console.log("getSearchAnomalyList error xxxx", error);

            setFetchingAnomalyList(false);
            setSearchingOVI(false);
        })
    }

    const getAnomalyDetectionList = (startDate, endDate) => {
        setIsFetchingAnomalyDetectionList(true);
        AnomalyDetectionService.getAnomalyDetectionList(startDate, endDate).then((res) => {
            console.log("getAnomalyDetectionList data xxxx", res.data);
            setIsFetchingAnomalyDetectionList(false);
            if (res.data.success) {
                setAnomalyDetectionList(res.data.data);    
            }

        }).catch((error) => {
            setIsFetchingAnomalyDetectionList(false);
            console.log("getAnomalyDetectionList error xxxx", error);
        })
    }
    
    

    return {anomalyDetectionDetails, isCreatingAnomalyDetectionRemarks, isRemarksSaved, isInvalidatingAnomalyDetectionRemarks, isRemarksInvalidated, anomalyHistoryLogList, isFetchingAnomalyDetails,
        getAnomalyDetectionDetailView, createAnomalyDetectionRemarks, invalidateAnomalyDetectionRemarks, getHistoryLogList, getAnomalyList, getSearchAnomalyList, 
        searchedResult, isSearchingOVI, anomalyList, isFetchingAnomalyList, getAnomalyDetectionList, anomalyDetectionList, isFetchingAnomalyDetectionList
    } 
    
}

export default useAnomalyDetection